import * as Sentry from "@sentry/react";
import { startAnalytics } from "./lib/analytics";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.2,
  enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

startAnalytics();

import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { AppCrashFallback } from "./components/AppCrashFallback";
import "./styles.css";
import "./app-overrides.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<AppCrashFallback />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
